import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { CountryApiService } from 'src/app/modules/attorney/services/country.service';
import { FindPetitionerService } from './find-petitioner.service';
import { forkJoin } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-find-petitioner',
  templateUrl: './find-petitioner.component.html',
  styleUrls: ['./find-petitioner.component.scss']
})
export class FindPetitionerComponent implements OnInit {

  petitionerForm: FormGroup;
  employeeResults: any[];
  naicsResults: any[];
  stateList: any[];
  findEmployerResult: any[];
  cols: any[];
  userType;
  totalElementCount: number = 0;
  pageSizeOptions = [25, 50, 100];
  pageNumber: number = 0;//default
  recordsPerPage: number = 25;//default
  employerDialogDisplay:boolean = false;
  gcFilingsResult;gcFilingsLength;
  lcaFilingsResult;lcaFilingsLength;
  petitonDataResult;petitonDataLength;
  individualCompany : any[];

  constructor(private formBuilder: FormBuilder,
    private countryApiService: CountryApiService,
    private toastr: ToastrService,
    private findPetitionerService: FindPetitionerService) { }

  ngOnInit() {
    this.petitionerForm = this.formBuilder.group({
      employeeName: ["", [Validators.required]],
      naicsCode: ["", [Validators.required]],
      state: ["", [Validators.required]],
    });
    this.getStateList();

  }

  getStateList(){
    this.countryApiService.getStates('USA').subscribe((states: []) => {
      this.stateList = states;
    });
  }

  filterEmployee(event) {
    const query = event.query;
    if(query.length > 2)
      this.getEmployeeList(query);
    //this.employeeResults = filtered;
  }

  getEmployeeList(param){
    this.findPetitionerService.getEmployerList(param).subscribe((employee: []) => {
      this.employeeResults = employee;
    });
  }

  filterNaics(event){
    const query = event.query;
    //if(query.length > 2)
      this.getNaicsList(query);
  }

  getNaicsList(param){
    this.findPetitionerService.getNaicsList(param).subscribe((states: []) => {
      this.naicsResults = states;
    });
  }

  searchPetitioner(){
    let payload = {
      "employerName": this.petitionerForm.controls['employeeName'].value  != "" ? this.petitionerForm.controls['employeeName'].value['employerName'] : '',
      "employerState": this.petitionerForm.controls['state'].value  != "" ? this.petitionerForm.controls['state'].value['stateProvinceCode'] : '',
      "naicsCode": this.petitionerForm.controls['naicsCode'].value  != "" ? this.petitionerForm.controls['naicsCode'].value['naicsCode'] : '',
      "pageNumber": this.pageNumber,
      "pageSize": this.recordsPerPage
    };
    this.findPetitionerService.findEmployerList(payload).subscribe((response : []) => {
      if(response['totalElementCount'] > 0){
        let arr = [];
        Object.keys(response['companyList']).forEach(function(key) {
          let val = response['companyList'][key];
          let dataObj = {
            id: val[0].imgMappingCompId,
            naicsCode: val[0].naicsCode,
            imgMappingCompId: val[0].imgMappingCompId,
            companyName: val[0].companyName,
            naicsTitle: val[0].naicsTitle,
            state: val[0].state,
            isFavorite:val[0].isFavorite,
          }
          arr.push(dataObj);
        });
        //this.noData = 1;
        arr.sort((a, b) => a.companyName.localeCompare(b.companyName));
        this.findEmployerResult = arr;
          this.totalElementCount = response['totalElementCount'];
      }
      else {
        this.findEmployerResult = []
      }
    });
  }

  paginationEvent(event) {
    this.pageNumber = event.page + 1;
    this.recordsPerPage = event.rows;
    this.searchPetitioner();
  }

  markFav(item)
  {
    let companyID = item.id;
    let beneficiaryID = parseInt(sessionStorage.getItem('loggedInBeneficiaryId'));
    this.findPetitionerService.markFavourite(beneficiaryID, companyID).subscribe(result => {
      if(result['status'] === 200){
        this.toastr.success(result['message'], 'Success');
        this.searchPetitioner();
      }
    });
  }

  showCompanyInfo(item){
    this.individualCompany = [];
    this.employerDialogDisplay = true;
    this.individualCompany.push(item);
    this.getEmployerData(item);
  }

  closeCompanyInfo(){
    this.employerDialogDisplay = false;
  }

  getEmployerData(item){
    let payload = {
      "employerName": item['companyName']
    }
    forkJoin([
      this.findPetitionerService.getGcFilings(payload),
      this.findPetitionerService.getLcaFilings(payload),
      this.findPetitionerService.getPetitonData(payload)
    ]).subscribe(([gcFilings, lcaFilings, petitonData]) => {
      if(gcFilings['totalElementCount'] > 0){
        let arr = [];
        Object.keys(gcFilings['lcaList']).forEach(function(key) {
          let val = gcFilings['lcaList'][key];
          let dataObj = {
            year: key,
            certifiedExpired: val['certified-expired'] ? val['certified-expired'] : '-',
            certified: val['certified'] ? val['certified'] : '-',
            denied: val['denied'] ? val['denied'] : '-',
            withdrawn: val['withdrawn'] ? val['withdrawn'] : '-'
          }
          arr.push(dataObj);
        });
        this.gcFilingsResult = arr;
      }
      else{
        this.gcFilingsResult = [];
      }
      if(lcaFilings['totalElementCount'] > 0){
        let arr = [];
        Object.keys(lcaFilings['lcaList']).forEach(function(key) {
          let val = lcaFilings['lcaList'][key];
          let dataObj = {
            year: key,
            certifiedExpired: val['certified-expired'] ? val['certified-expired'] : '-',
            certified: val['certified'] ? val['certified'] : '-',
            denied: val['denied'] ? val['denied'] : '-',
            withdrawn: val['withdrawn'] ? val['withdrawn'] : '-'
          }
          arr.push(dataObj);
        });
        this.lcaFilingsResult = arr;
      }
      else{
        this.lcaFilingsResult = [];
      }
      this.gcFilingsLength = gcFilings['totalElementCount'];
      this.lcaFilingsLength = lcaFilings['totalElementCount'];
      this.petitonDataLength = petitonData['totalElementCount'];
      this.petitonDataResult = petitonData['permList']; 
  });
}

}
